module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/img01-cb288305cdd3d86d20bb8bd100ba40ba.png";